import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

export const HeaderContainer = styled.header`
  position: absolute; 
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5%;
  z-index: 1000;
  background: rgba(53, 53, 53, 0.2); 
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  
  @media (max-width: 1024px) {
    padding: 1rem;
  }
`;

export const Logo = styled(Link)`
  height: 40px;
  
  img {
    height: 100%;
    filter: ${props => props.scrolled ? 'none' : 'brightness(0) invert(1)'};
    transition: filter 0.3s ease;
  }
  
  @media (max-width: 768px) {
    height: 35px;
  }
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled(Link)`
  margin: 0 1rem;
  color: ${props => props.active === "true" ? '#0066FF' : '#fff'};
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #0066FF;
  }
`;

export const MobileNavItem = styled(NavLink)`
  color: white;
  text-decoration: none;
  font-weight: 500;
  padding: 0.7rem 2rem;
  transition: background-color 0.3s ease;
  font-size: 1.1rem;

  &.active {
    color: #0066FF;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
    color: #0066FF;
  }
`;

export const MobileButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 2rem;
  margin-top: 0;
  margin-bottom: 0;
`;

export const MobileButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem;
  border-radius: 50px;
  border: none;
  background: ${props => props.primary ? '#0066FF' : 'transparent'};
  color: white;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 1rem;
  width: 100%;
`;

export const MobileLoginButton = styled(MobileButton)`
  background: transparent;
  border: 1px solid white;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  border: none;
  background: ${props => props.primary ? 'linear-gradient(90deg, #0066FF 0%, #0044CC 100%)' : 'transparent'};
  color: ${props => props.primary ? 'white' : '#333'};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 1rem;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const LoginButton = styled(Button)`
  background: transparent;
  border: 1px solid ${props => props.scrolled ? '#0066FF' : '#fff'};
  color: ${props => props.scrolled ? '#0066FF' : '#fff'};
  transition: all 0.3s ease;
`;

export const ButtonText = styled.span`
  margin-right: 0.5rem;
`;

export const ButtonIcon = styled.div`
  width: 20px;
  height: 20px;
  
  img {
    width: 100%;
    height: 100%;
  }
`;

export const MenuToggle = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: white;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileMenuOverlay = styled.div`
  display: ${props => props.isOpen ? 'block' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
`;

export const MobileMenuContainer = styled.div`
  display: ${props => props.isOpen ? 'flex' : 'none'};
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw; 
  max-width: 100vw;
  height: 100vh;
  background-color: #000;
  z-index: 1002;
  overflow: hidden; /* Evita scroll */
  box-sizing: border-box;
`;

export const MobileMenuContent = styled.div`
  display: flex;
  flex-direction: column;
  height: auto; 
  padding-bottom: 20px;
  justify-content: space-between;
`;

export const MobileMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const MobileMenuLogo = styled.div`
  height: 35px;
  
  img {
    height: 100%;
    filter: brightness(0) invert(1); 
  }
`;

export const MobileMenuActions = styled.div`
  display: flex;
  align-items: center;
`;

export const SearchButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  margin-right: 1rem;
  cursor: pointer;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #FF7A00;
  font-size: 1.2rem;
  cursor: pointer;
`;

export const MobileNavItems = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  margin-bottom: 2rem; 
`;